export const removeArrDuplicates = <T>(
  arr: T[],
  keyToCompareWith: keyof T
): T[] => {
  if (arr.length === 0) return [];

  // For array of objects
  if (typeof arr[0] === 'object') {
    return Array.from(
      new Map(arr.map(item => [item[keyToCompareWith], item])).values()
    );
  }

  // For primitives
  return [...new Set(arr)];
};